"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SearchResultsContainerComponent = SearchResultsContainerComponent;
const GraphQLQuery = __importStar(require("@genesys/client-core/lib/graphql-query"));
const screen_amount_profile_1 = require("@genesys/client-core/lib/screen-amount-profile");
const UserProfile = __importStar(require("@genesys/client-core/lib/user-profile"));
const property_1 = require("@genesys/property");
const DateHelper = __importStar(require("@genesys/shared/lib/date-helper"));
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const React = __importStar(require("react"));
const Actions = __importStar(require("../actions"));
const SearchResultsComponent = __importStar(require("./components/search-results-component"));
const functions_1 = require("./functions");
const searchQueryUser = (0, graphql_tag_1.default) `
  query AdvancedProductsSearch_SearchResultContainerComponent_SearchUser(
    $filter: AdvancedProductSearchInputType!
  ) {
    user {
      advancedProductSearch(filter: $filter) {
        id
        results {
          id
          systemId
          genesysNo
          revisionNo
          ownerUserName
          ownerName
          lastModifiedBy
          systemStatus
          priceDate
          statusDate
          productId
          properties
          operatingCaseResults {
            sortNo
            caseName
            result
          }
        }
        error
      }
    }
  }
`;
const searchQueryProduct = (0, graphql_tag_1.default) `
  query AdvancedProductsSearch_SearchResultContainerComponent_SearchProduct {
    product {
      genesysNumberPrefixes {
        id
        genesysNo
      }
    }
  }
`;
function SearchResultsContainerComponent(props) {
    return (React.createElement(GraphQLQuery.QueryProductSimple, { query: searchQueryProduct, variables: {} }, ({ product: { genesysNumberPrefixes } }) => (React.createElement(UserProfile.UserProfile, null, ({ locale }) => (React.createElement(GraphQLQuery.QueryUserSimple, { query: searchQueryUser, variables: {
            filter: {
                productId: props.searchOptions.productId,
                productPropertyFilter: props.searchOptions.productPropertyFilter,
                operatingCaseResultsPropertyFilter: props.searchOptions.operatingCaseResultsPropertyFilter,
                fromDate: props.searchOptions.fromDate,
                toDate: props.searchOptions.toDate
            }
        } }, ({ user: { advancedProductSearch } }) => {
        const results = advancedProductSearch.results.map((result) => ({
            systemId: (result.systemId || "").toString(),
            genesysNo: result.genesysNo.toString(),
            revisionNo: result.revisionNo.toString(),
            ownerUserName: result.ownerUserName || "",
            ownerName: result.ownerName || "",
            lastModifiedBy: result.lastModifiedBy || "",
            systemStatus: result.systemStatus,
            priceDate: result.priceDate
                ? DateHelper.getDateString(DateHelper.fromUTC(result.priceDate), locale)
                : "N/A",
            statusDate: DateHelper.getDateString(DateHelper.fromUTC(result.statusDate), locale),
            productId: result.productId,
            properties: result.properties || "",
            operatingCaseResults: result.operatingCaseResults
        }));
        // Sort results.
        const sortColumn = props.sorting.column;
        if (sortColumn) {
            results.sort((a, b) => (a[sortColumn.name] + "").localeCompare(b[sortColumn.name] + ""));
            if (!sortColumn.ascending) {
                results.reverse();
            }
        }
        const sortProperty = props.sorting.property;
        if (sortProperty) {
            results.sort((a, b) => {
                const pvsA = property_1.PropertyValueSet.fromString(a.properties);
                const pvsB = property_1.PropertyValueSet.fromString(b.properties);
                const valueA = property_1.PropertyValueSet.getValue(sortProperty.name, pvsA);
                const valueB = property_1.PropertyValueSet.getValue(sortProperty.name, pvsB);
                if (valueA && !valueB) {
                    return 1;
                }
                if (!valueA && valueB) {
                    return -1;
                }
                if (property_1.PropertyValue.greaterThan(valueA, valueB)) {
                    return 1;
                }
                if (property_1.PropertyValue.lessThan(valueA, valueB)) {
                    return -1;
                }
                return 0;
            });
            if (!sortProperty.ascending) {
                results.reverse();
            }
        }
        const itemsPerPage = 100;
        const totalItems = results.length;
        const numberOfPages = Math.ceil(totalItems / itemsPerPage);
        const firstResultItem = itemsPerPage * (props.currentPage - 1);
        return (React.createElement(screen_amount_profile_1.ScreenAmountProfile, null, ({ getAmountFormat }) => (React.createElement(SearchResultsComponent.SearchResultsComponent, { error: advancedProductSearch.error || undefined, productId: props.searchOptions.productId, results: results.slice(firstResultItem, firstResultItem + itemsPerPage), properties: props.searchOptions.properties, resultProperties: props.searchOptions.resultProperties, genesysNumberPrefix: genesysNumberPrefixes.genesysNo, generateCsvData: () => resultToFile(props.searchOptions.productId, results, genesysNumberPrefixes.genesysNo, props.searchOptions.properties, props.searchOptions.resultProperties, getAmountFormat), pagination: {
                currentPage: props.currentPage,
                itemsPerPage,
                numberOfPages,
                onPageChange: (page) => props.dispatch(Actions.setPage(page)),
                onRefresh: () => {
                    /*  */
                },
                totalItems
            }, 
            // This is ugly. Move to own container+mapStateToProps?
            dispatch: props.dispatch }))));
    }))))));
}
// Types.ResultRow
function resultToFile(productId, results, genesysNumberPrefix, properties, resultProperties, getAmountFormat) {
    return [
        [
            "GenesysNo",
            "RevisionNo",
            "OwnerUsername",
            "OwnerName",
            "LastModifiedBy",
            "SystemStatus",
            "PriceDate",
            "StatusDate",
            "ProductId",
            ...properties.map((propertyName) => {
                const unitLabel = (0, functions_1.getUnitLabel)(productId, "Property", propertyName, getAmountFormat, results.map((x) => property_1.PropertyValueSet.fromString(x.properties)));
                return `${propertyName} ${unitLabel}`;
            }),
            ...resultProperties.map((resultName) => {
                const unitLabel = (0, functions_1.getUnitLabel)(productId, "Result", resultName, getAmountFormat, results.flatMap((x) => x.operatingCaseResults.map((y) => property_1.PropertyValueSet.fromString(y.result))));
                return `${resultName} ${unitLabel}`;
            })
        ]
    ].concat(results.map((row) => {
        const propertiesPvs = property_1.PropertyValueSet.fromString(row.properties);
        const caseResults = row.operatingCaseResults.map((results) => ({
            sortNo: results.sortNo,
            caseName: results.caseName,
            result: property_1.PropertyValueSet.fromString(results.result)
        }));
        return [
            genesysNumberPrefix + row.genesysNo + "-" + row.revisionNo,
            row.revisionNo,
            row.ownerUserName,
            row.ownerName,
            row.lastModifiedBy,
            row.systemStatus,
            row.priceDate,
            row.statusDate,
            row.productId,
            ...properties.map((propertyName) => (0, functions_1.getPropertyValue)(productId, "Property", propertyName, getAmountFormat, property_1.PropertyValueSet.get(propertyName, propertiesPvs))),
            ...resultProperties.map((propertyName) => {
                return caseResults
                    .sort((a, b) => a.sortNo - b.sortNo)
                    .filter((caseResult) => property_1.PropertyValueSet.hasProperty(propertyName, caseResult.result))
                    .map((caseResult) => {
                    const propertyValue = (0, functions_1.getPropertyValue)(productId, "Result", propertyName, getAmountFormat, property_1.PropertyValueSet.get(propertyName, caseResult.result));
                    return `${caseResult.caseName} : ${propertyValue}`;
                })
                    .join(", ");
            })
        ];
    }));
}
//# sourceMappingURL=container-component.js.map